/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import { LabelWithRequired, LabelWithRequiredProps } from '@motili/ui';
import { useTheme } from 'styled-components';

export default function StyledLabelWithRequired({
    style,
    ...props
}: LabelWithRequiredProps) {
    const { components } = useTheme();
    return (
        <LabelWithRequired
            style={{ ...components.labelWithRequired.style, ...style }}
            {...props}
        />
    );
}
